import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { Box } from '@allied-solutions/affinity'

import { ArticleCard } from './ArticleCard'
import { camelCase } from 'lodash'

const ArticleGrid = ({
  mb,
  px = 'md',
  gap: gapProp = ['md', '4xl'],
  ...rest
}) => {
  const { articles } = useStaticQuery(graphql`
    {
      articles: allMdx(
        filter: { fileAbsolutePath: { glob: "**/support/*" } }
        sort: { fields: frontmatter___order }
      ) {
        edges {
          node {
            frontmatter {
              path
              tag
              title
            }
          }
        }
      }
    }
  `)

  return (
    <Box
      display="flex"
      flexDirection={['column', 'row']}
      flexWrap="nowrap"
      alignItems="stretch"
      mb={mb}
      gap={gapProp}
      {...rest}
    >
      {articles?.edges?.map(({ node }) => (
        <ArticleCard
          {...node.frontmatter}
          key={`ArticleCard--${camelCase(node.frontmatter.title)}`}
        />
      ))}
    </Box>
  )
}

export { ArticleGrid }
